<template>
  <div class="myresponse overflow-x-hide" style="background: #eeeff0">
    <div class="container no-padding">
      <div class="row no-margin" style="overflow: hidden !important">
        <div class="col-md-11" :class="showMenu ? 'opacity-8' : ''">
          <headerlogo :page-type="'404'" />

          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-md-12 flex-container">
              <brandpattern page="MYRESPONSES" class="!tw-top-[30px]" />
            </div>
          </div>
        </div>

        <errorhandler
          v-if="showProspectCallbackError || null"
          :prospect-callback-error-msg="prospectCallbackErrorMsg"
          @reset-show-prospect-callback-error="resetShowProspectCallbackError"
        />

        <!-- Modal -->

        <div
          id="responseModal"
          class="modal fade myresponse-modal"
          aria-labelledby="responseModalLabel"
          data-bs-backdrop="false"
          data-bs-keyboard="false"
        >
          <div
            class="modal-dialog overflow-y-hide"
            role="document"
            :style="{ height: modalDialogHeight }"
          >
            <div class="modal-content">
              <div class="modal-header !tw-justify-between">
                <div class="response-modal-heading float-left">
                  {{ getUiText("app-prospect-questions-responses-heading-1") }}
                </div>
                <button
                  type="button"
                  class="close"
                  data-bs-dismiss="modal"
                  @click="onClickContinue"
                >
                  <img src="@/assets/img/close.svg" />
                </button>
              </div>

              <div class="modal-body">
                <div class="modal-body-before" />
                <div
                  class="modal-body-sec"
                  :style="{ height: modalBodySecHeight }"
                >
                  <div
                    v-for="(item, itemIndex) in allProsQstnGroupsData"
                    :key="itemIndex"
                    class="modal-text"
                  >
                    <div class="modal-questions">
                      <div class="modal-questions-sec">
                        <div class="modal-questions-heading">
                          <span>{{ itemIndex + 1 }}.</span>
                          <span class="modal-questions-heading-2">{{
                            item.name
                          }}</span>
                        </div>
                        <div
                          class="response-modal-edit"
                          @click="onClickEdit(itemIndex)"
                        >
                          {{ getUiText("app-nav-link-edit-1") }}
                        </div>
                      </div>
                      <div
                        v-for="(item2, itemIndex2) in item.prospect_questions"
                        :key="itemIndex2"
                      >
                        <div class="modal-QA">
                          <div class="question-class">
                            {{ item2.name }} <span> : </span>
                          </div>
                          <div class="answer-class">
                            {{ item2.displayVal }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="div-separator" />
                  </div>
                </div>
                <div class="modal-body-after" />
              </div>
              <div class="modal-footer">
                <div class="btn-container">
                  <button
                    type="button"
                    class="btn great-btn"
                    @click="onClickContinue"
                  >
                    {{
                      getUiText(
                        "app-prospect-questions-responses-button-continue-1",
                      )
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-md-1 no-padding lg-menu-view"
          :style="{ 'min-height': dyn_height }"
        >
          <div class="right-menu">
            <div class="elipse-menu" @click="slideMenu">
              <span><img src="@/assets/img/elipse_menu.svg" /></span>
            </div>
          </div>
        </div>
        <sidebar
          :show-menu="showMenu"
          @my-response="myResponse"
          @create-account="createAccount"
          @close-menu="closeMenu"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import HeaderLogo from "@/components/common/headerLogo.vue";
import SideBar from "@/components/common/prospectQuestionsMenu.vue";
import $ from "jquery";

import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import ProspectService from "@/services/prospect/prospectService";
import _ from "underscore";
import errorhandler from "@/components/common/exceptionHandler.vue";
import store from "@/store";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import { Modal } from "bootstrap";

@Component({
  components: {
    brandpattern: BrandPattern2,
    headerlogo: HeaderLogo,
    sidebar: SideBar,
    errorhandler,
  },
})
export default class MyResponse extends Vue {
  showMenu = false;
  dyn_height = "0";
  windowHeight = "";
  modalDialogHeight = "";
  modalBodySecHeight = "";
  public allProsQstnGroupsData: any = [];
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";
  responseModalInstance: any = null;

  get prospectQuestionGroups() {
    return store.state.ProspectQuestions.prospectQuestionGroups;
  }
  get currQuestionGroupIndex() {
    return store.state.ProspectQuestions.currQuestionGroupIndex;
  }

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  created() {}
  async mounted() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg page-shadow");
    }

    const responseModal = document.getElementById("responseModal");
    if (responseModal) {
      this.responseModalInstance = new Modal(responseModal);
      this.responseModalInstance.show();
    }

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
    this.setLanguages();
    await this.getQuestionsData();
  }

  async setLanguages() {
    if (
      localStorage.getItem(localStorageKey.languagesData) == null ||
      localStorage.getItem(localStorageKey.languageList) == null
    ) {
      await Utils.getV3Recaptcha().then(
        async (finalKey: any) => {
          const recaptcha = await load(`${finalKey}`, {
            autoHideBadge: true,
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguages", token);
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguageList", token);
          });
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    }
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  async getQuestionsData() {
    if (
      !this.prospectQuestionGroups ||
      this.prospectQuestionGroups.length <= 0
    ) {
      const prospectService = new ProspectService();
      let data = { language: this.languageSelected };
      prospectService.getProspectQuestions(data).then(
        async (response: any) => {
          localStorage.removeItem("csrfReloadDone");
          if (
            response.data &&
            response.data.data &&
            response.data.data.prospect_question_groups
          ) {
            if (response.data.data.prospect_question_groups.length > 0) {
              sessionStorage.setItem(
                "questionsData",
                JSON.stringify(response.data.data),
              );
              await this.$store.dispatch(
                "ProspectQuestions/setProsQuesGroups",
                response.data.data.prospect_question_groups,
              );
              await this.setAnswersInfo();
            } else {
              let errorObject = {
                message: this.getUiText("app-prospect-error-no-questions"),
              };
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(errorObject),
              );
              this.$router.push({ path: "/" });
            }
          }
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            if (localStorage.getItem("csrfReloadDone") == null) {
              localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
              this.$router.go(0);
            }
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    } else {
      this.setAnswersInfo();
    }
  }
  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }

  async setAnswersInfo() {
    let prosQstnGrpsData: any = [].concat(this.prospectQuestionGroups);
    for (let i = 0; i < prosQstnGrpsData.length; i++) {
      for (let j = 0; j < prosQstnGrpsData[i].prospect_questions.length; j++) {
        let displayVal = " ";
        let info = prosQstnGrpsData[i].prospect_questions[j];
        if (info && info.values && info.values.length > 0) {
          if (info.question_display_type === "text") {
            displayVal = info.values.join(", ");
          } else if (info.question_display_type === "single-list-2") {
            let currencyList = Object.keys(info.type_values);
            let selectedItem = " ";
            let selectedAmount: any = { from: "", id: "" };
            let amountList: any[] = [];
            let lowerRange: any;
            let upperRange: any;
            if (info && info.values && info.values.length > 0) {
              for (let i = 0; i < currencyList.length; i++) {
                let revenueList = info.type_values[currencyList[i]];
                if (revenueList.find((r: any) => r.id === info.values[0])) {
                  selectedItem = currencyList[i];
                  selectedAmount = revenueList.find(
                    (r: any) => r.id === info.values[0],
                  );
                  amountList = revenueList;
                }
              }
              for (let i = 0; i < amountList.length; i++) {
                if (i != amountList.length - 1) {
                  if (amountList[i].from % 1000000 !== 0) {
                    lowerRange = (amountList[i].from / 1000000)
                      .toString()
                      .substring(
                        0,
                        ((amountList[i + 1].from - 1) / 1000000)
                          .toString()
                          .indexOf(".") + 2,
                      );
                  } else {
                    lowerRange = amountList[i].from / 1000000;
                  }
                  if ((amountList[i + 1].from - 1) / 1000000 !== 0) {
                    upperRange = ((amountList[i + 1].from - 1) / 1000000)
                      .toString()
                      .substring(
                        0,
                        ((amountList[i + 1].from - 1) / 1000000)
                          .toString()
                          .indexOf(".") + 2,
                      );
                  } else {
                    upperRange = (amountList[i + 1].from - 1) / 1000000;
                  }
                  amountList[i].amountRange =
                    lowerRange + "m" + " - " + upperRange + "m";
                } else {
                  amountList[i].amountRange =
                    ">= " + amountList[i].from / 1000000 + "m";
                }
              }
              displayVal = selectedItem + " " + selectedAmount.amountRange;
            }
          } else if (
            info.question_display_type === "multi-level-multi-search"
          ) {
            let listKeyInJSON = await Utils.getQuestionsMatchedListKey(info.id);
            if (
              info.type_values[listKeyInJSON] &&
              info.type_values[listKeyInJSON].length > 0
            ) {
              let typeVals = info.type_values[listKeyInJSON];
              typeVals = _.sortBy(typeVals, "order");
              const selectedVals: any = await this.getMultiLevelData(
                typeVals,
                info.values,
                info.id,
              );
              if (selectedVals && selectedVals.length > 0) {
                displayVal = selectedVals.join(", ");
              }
            }
          } else {
            if (
              info.type_values &&
              info.type_values != null &&
              info.type_values != undefined
            ) {
              let listKeyInJSON = await Utils.getQuestionsMatchedListKey(
                info.id,
              );
              if (
                info.type_values[listKeyInJSON] &&
                info.type_values[listKeyInJSON].length > 0
              ) {
                const valsSplit = info.values;
                let valsList: any[] = [];
                for (let p of valsSplit) {
                  const keyVal: any = _.findWhere(
                    info.type_values[listKeyInJSON],
                    { id: p },
                  );
                  // 'if' is Special case for 'single-bubble' with id 'staff_count'.
                  if (
                    info.question_display_type === "single-bubble" &&
                    info.id === "staff_count"
                  ) {
                    if (keyVal && keyVal.from >= 0) {
                      let allVals: any = "";
                      const itemRecIndex = info.type_values[
                        listKeyInJSON
                      ].findIndex((r: any) => r.id == p);
                      if (itemRecIndex >= 0) {
                        if (
                          itemRecIndex ===
                          info.type_values[listKeyInJSON].length - 1
                        ) {
                          allVals = ">= " + keyVal.from;
                        } else if (
                          info.type_values[listKeyInJSON][itemRecIndex + 1] &&
                          info.type_values[listKeyInJSON][itemRecIndex + 1].from
                        ) {
                          allVals =
                            "" +
                            keyVal.from +
                            " - " +
                            (parseInt(
                              info.type_values[listKeyInJSON][itemRecIndex + 1]
                                .from,
                            ) -
                              1);
                        } else {
                          allVals = "" + keyVal.from;
                        }
                      }
                      valsList.push(allVals);
                    }
                  } else {
                    if (keyVal && keyVal.name) {
                      valsList.push(keyVal.name);
                    }
                  }
                }
                if (valsList && valsList.length > 0) {
                  displayVal = valsList.join(", ");
                }
              }
            }
          }
        }
        prosQstnGrpsData[i].prospect_questions[j].displayVal = displayVal;
      }
    }
    this.allProsQstnGroupsData = prosQstnGrpsData;
  }
  onResize() {
    this.dyn_height = (window.innerHeight + "px") as string;
    this.windowHeight = "" + window.innerHeight + "px !important ";

    if (window.innerHeight < 300) {
      this.modalDialogHeight = (window.innerHeight + "px") as string;
      this.modalBodySecHeight = (window.innerHeight - 110 + "px") as string;
    } else if (window.innerHeight < 500) {
      this.modalDialogHeight = (window.innerHeight - 30 + "px") as string;
      this.modalBodySecHeight = (window.innerHeight - 150 + "px") as string;
    } else if (window.innerWidth < 768) {
      this.modalDialogHeight = (window.innerHeight - 150 + "px") as string;
      this.modalBodySecHeight = (window.innerHeight - 300 + "px") as string;
    } else {
      if (window.innerHeight < 900) {
        this.modalDialogHeight = (window.innerHeight - 90 + "px") as string;
        this.modalBodySecHeight = (window.innerHeight - 250 + "px") as string;
      } else if (window.innerHeight > 2000) {
        this.modalDialogHeight = (window.innerHeight - 170 + "px") as string;
        this.modalBodySecHeight = (window.innerHeight - 450 + "px") as string;
      } else {
        this.modalDialogHeight = (window.innerHeight - 170 + "px") as string;
        this.modalBodySecHeight = (window.innerHeight - 340 + "px") as string;
      }
    }
  }

  closeMenu() {
    this.showMenu = false;
  }
  slideMenu() {
    this.showMenu = true;
  }
  async onClickEdit(qstnIndex: number) {
    await this.$store.dispatch("ProspectQuestions/setCustomQG", qstnIndex);
    this.$router.push({ path: "/prospect/questions" });
  }
  async onClickContinue() {
    const sessQGI: any = sessionStorage.getItem("currQuestionGroupIndex")
      ? parseInt(sessionStorage.getItem("currQuestionGroupIndex") as any)
      : "";
    if (sessQGI === this.prospectQuestionGroups.length - 1) {
      this.$router.push({ path: "/prospect/createaccount" });
    } else {
      if (this.currQuestionGroupIndex !== sessQGI) {
        await this.$store.dispatch(
          "ProspectQuestions/setCustomQG",
          parseInt(sessQGI),
        );
        this.$router.push({ path: "/prospect/questions" });
      } else {
        this.$router.push({ path: "/prospect/questions" });
      }
    }
  }
  myResponse() {
    this.$router.push({ path: "/prospect/responses" });
  }
  createAccount() {
    this.$router.push({ path: "/prospect/createaccount" });
  }
  async getMultiLevelData(list: any, selectedVals: any, questionId: any) {
    if (list && list.length > 0 && selectedVals && selectedVals.length > 0) {
      let selectedItems: any = [];
      for (let i in list) {
        await this.checkInList(
          list[i],
          1,
          questionId,
          selectedVals,
          selectedItems,
        );
      }
      return selectedItems;
    }
  }
  async checkInList(
    list: any,
    level: any,
    questionId: any,
    selectedVals: any,
    selectedItems: any,
  ) {
    /* eslint-disable */
    for (let k in list) {
      const nextLevelListKey = await Utils.getListDataKeyAtLevel(
        questionId,
        level,
      );

      if (
        nextLevelListKey &&
        list[nextLevelListKey] &&
        list[nextLevelListKey].length > 0
      ) {
        if (Array.isArray(list[nextLevelListKey])) {
          const nxtLvl = level + 1;
          for (let k in list[nextLevelListKey]) {
            await this.checkInList(
              list[nextLevelListKey][k],
              nxtLvl,
              questionId,
              selectedVals,
              selectedItems,
            );
          }
        } else {
          await this.checkInList(
            list[nextLevelListKey],
            level + 1,
            questionId,
            selectedVals,
            selectedItems,
          );
        }
      } else if (_.isObject(list) && list.id) {
        if (selectedVals.length > 0) {
          await this.insertIfKeyValueExists(
            [list],
            selectedVals,
            selectedItems,
          );
        }
      }
    }
  }
  insertIfKeyValueExists(itemList: any, selectedVals: any, selectedItems: any) {
    const itemKey: string = "id";

    if (itemKey && itemList && itemList.length > 0) {
      for (let n: number = 0; n < selectedVals.length; n++) {
        let itemToCheck: any = {};
        itemToCheck[itemKey] = selectedVals[n];
        const itemRec = _.find(itemList, itemToCheck);
        if (itemRec && itemRec.name) {
          selectedItems.push(itemRec.name);
          selectedVals.splice(n, 1);
          n = n - 1;
        }
      }
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }
}
</script>
<style lang="scss" scoped>
.myresponse {
  background: linear-gradient(
      90deg,
      rgba(238, 239, 240, 0.38) 50%,
      #ffffff 94.92%
    ),
    #ffffff;
}
.myresponse-modal {
  pointer-events: none;
}
.modal-dialog {
  transition: none !important;
  transform: none !important;
}
.modal-content {
  border: hidden;
}

.modal-left-text {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;

  /* or 25px */

  /* UI / Dark */
  color: #231f20;
}

.modal-right-text {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 180%;

  /* or 25px */

  /* UI / Dark */
  color: #231f20;
}

.modal-header {
  border: hidden;
  padding: 0px 16px 5px 0px;
  justify-content: flex-end;
  .close {
    margin-top: -24px;
    padding: 0 !important;
    margin-right: 8px;
    opacity: 1;
  }
}
.modal-body {
  padding: 0 !important;

  .modal-body-sec {
    overflow-y: auto;
  }

  .modal-heading {
    font-size: 26px;
    color: #211f58;
    font-weight: 600;
    line-height: 39px;
    color: #0345bd;
  }
  .modal-text {
    color: #231f20;
  }
  .btn-container {
    margin-top: 38px;
  }
}
.modal-footer {
  border: hidden;
  padding: 5px 82px 15px 50px;
  display: block;

  .modal-footer-text {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #231f20;
  }
}
.modal-dialog {
  box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
  bottom: 5px;
  position: fixed;
  left: 0;
  right: 0;
  overflow-y: scroll;
}

.width-280 {
  right: 0px;
}
.width-0 {
  right: -100%;
}
.right-top-menu {
  top: 0px;
  width: 280px;
  background: #0345bd;
  box-shadow: inset 0px 2px 4px rgba(33, 31, 88, 0.15);
  position: fixed;
  height: 100%;
  overflow-x: hidden;
  -webkit-transition: right 0.5s ease;
  -moz-transition: right 0.5s ease;
  -o-transition: right 0.5s ease;
  -ms-transition: right 0.5s ease;
  transition: right 0.5s ease;
  z-index: 1060;

  .menu-content {
    margin-top: 50.4px;
  }
  .menu-close {
    .close {
      color: #211f58;
      opacity: 1 !important;
      padding-right: 41px;
    }
    img {
      width: 19.09px;
      height: 19.09px;
    }
  }

  .menu-content-sec {
    display: inline-grid;
    margin-top: 56.45px;
  }

  .menu-content-sec1 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    color: #ffffff;
    padding-right: 41px;
  }

  .menu-content-sec2 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    color: #ffffff;
    margin-top: 47px;
    padding-right: 41px;
  }

  .menu-content-sec3 {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    text-align: right;
    margin-top: 116px;
    position: relative;
    color: #ffffff;
    padding-right: 41px;

    a {
      color: #ffffff;
      font-weight: bold;
      text-decoration: underline;
    }
  }

  .menu-content-last {
    bottom: 0px;
    position: absolute;
    padding-bottom: 41.5px;
    right: 45px;
    float: right;

    img {
      width: 123px;
      height: 27.53px;
    }
  }
}
.elipse-menu {
  cursor: pointer;
  position: relative;
}
.elipse-menu-mb {
  display: none;
  cursor: pointer;
  position: static;
  text-align: center;
  top: unset;
}
.right-menu {
  background: rgba(238, 239, 240, 0.3);
  height: 100%;
}
.menu-separation {
  border-bottom: 1px solid #ffffff;
  padding-top: 50px;
  opacity: 0.1;
}
.response-modal-heading {
  color: #0345bd;
  margin-left: 70px;
  margin-top: 60px;
}
.modal-questions {
  color: #231f20;
}
.modal-questions-heading {
  color: #231f20;
}
.modal-questions-heading-2 {
  padding-left: 10px;
}
.response-modal-edit {
  display: inline-block;
  float: right;
  cursor: pointer;
  font-weight: 500;
}
.div-separator {
  border: 1px solid #b7b7b7;
  opacity: 0.3;
}
.btn-container {
  margin-left: 20px;
  margin-right: 0px;
}
.great-btn {
  background: #0345bd !important;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  border-radius: 26.9091px;
  color: white !important;
  font-size: 16px;
  padding: 5px 20px;
  border: none;
}
.question-class {
  float: left;
  font-weight: 500;
}
.answer-class {
  font-weight: 400;
}
.modal-QA {
  display: flex;
  width: 100%;
  line-height: 25.2px;
}
.modal-body-before {
  @extend .fade-body-before;
}
.fade-body-before {
  content: "";
  background: linear-gradient(to top, rgba(255, 255, 255, 0.5), white);
  height: 50px;
  width: 90%;
  position: absolute;
  z-index: 999;
  margin-top: -1px;
}
.modal-body-after {
  @extend .fade-body-after;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1) 88%
  );
  z-index: 1040;
}
.fade-body-after {
  height: 60px;
  width: 90%;
  vertical-align: bottom;
  position: absolute;
  bottom: -2px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 1) 90%
  );
  // background: linear-gradient(90deg, rgba(238, 239, 240, 0.38) 30%, #FFFFFF 94.92%), #FFFFFF;
}
</style>
